import React, { useState } from 'react';

import { Box, styled } from '@mui/system';
import { TextField, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import EditIconRounded from '@mui/icons-material/EditRounded';
import CloseIcon from '@mui/icons-material/Close';

import { COLOR_PRIMARY_2, COLOR_TEXT_1, COLOR_TEXT_GREY } from 'src/colors';

const SaveBox = styled('div')({
  position: 'absolute',
  top: '-120px',
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: '12px',
  width: '200px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  zIndex: 999999,
  '& .MuiTextField-root': {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: COLOR_PRIMARY_2,
      },
      '&:hover fieldset': {
        borderColor: COLOR_PRIMARY_2,
      },
    },
  },
  '& .MuiButton-root': {
    backgroundColor: COLOR_PRIMARY_2,
    color: '#fff',
    '&:hover': {
      backgroundColor: COLOR_PRIMARY_2,
      opacity: 0.9,
    },
  },
});

const CloseButton = styled('div')({
  position: 'absolute',
  top: '5px',
  right: '5px',
  cursor: 'pointer',
  color: COLOR_TEXT_GREY,
  '&:hover': {
    color: COLOR_TEXT_1,
  },
});

const SaveBoxPointer = ({
  lat,
  lng,
  currentClusterName,
  savedClusters,
  clusterId,
  performanceMetrics,
  supply,
  marketID,
  setSavedClusters,
  clusterKey,
  setClickedClusterData,
}: {
  lat?: number;
  lng?: number;
  currentClusterName: string;
  savedClusters: any;
  clusterId: string;
  performanceMetrics: any;
  supply: number;
  marketID: string;
  setSavedClusters: (value: any) => void;
  clusterKey: string;
  setClickedClusterData: React.Dispatch<React.SetStateAction<any>>;
}) => {
  const isThisClusterSaved = savedClusters[clusterId];
  const [inputValue, setInputValue] = useState<string>(currentClusterName || '');
  const [isEditMode, setIsEditMode] = useState<boolean>(isThisClusterSaved ? false : true);

  const handleSave = () => {
    // Handle save logic here
    const listingCount: number = supply;
    const adr: number = performanceMetrics.adr;
    const occupancyRate: number = performanceMetrics.occupancyRate;
    const revPar: number = performanceMetrics.revPar;

    const savedClusterObject = {
      name: inputValue,
      listingCount,
      adr,
      occupancyRate,
      revPar,
      clusterKey,
    };

    const getSavedClustersDataFromLocalStorage = localStorage.getItem('savedClustersData');
    const savedClustersData = JSON.parse(getSavedClustersDataFromLocalStorage || '{}');

    savedClustersData[marketID] = savedClustersData[marketID] || {};
    savedClustersData[marketID][clusterId] = savedClusterObject;
    setSavedClusters(prev => ({ ...prev, [clusterId]: savedClusterObject }));

    localStorage.setItem('savedClustersData', JSON.stringify(savedClustersData));
    setClickedClusterData(null);
  };

  return (
    <SaveBox onClick={e => e.stopPropagation()}>
      {lat && lng && (
        <Box
          style={{
            position: 'absolute',
            top: '8px',
            right: '8px',
            cursor: 'pointer',
            backgroundColor: 'white',
            width: '24px',
            height: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            border: `2px solid ${COLOR_PRIMARY_2}`,
            zIndex: 10,
          }}
          onClick={e => {
            e.stopPropagation();
            setClickedClusterData(null);
          }}
        >
          <CloseIcon style={{ fontSize: '14px', color: COLOR_PRIMARY_2 }} />
        </Box>
      )}

      {isEditMode && (
        <TextField
          size="small"
          placeholder="Enter a Name ..."
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          onClick={e => e.stopPropagation()}
          onMouseDown={e => e.stopPropagation()}
          fullWidth
        />
      )}

      {!isEditMode && (
        <Typography variant="body1" sx={{ color: COLOR_TEXT_1 }}>
          <span style={{ color: COLOR_TEXT_GREY, fontWeight: 500 }}>Area name: </span>
          {(currentClusterName && currentClusterName.slice(0, 20)) +
            (currentClusterName && (currentClusterName.length > 20 ? '...' : ''))}
        </Typography>
      )}

      <Button
        variant="contained"
        startIcon={isEditMode ? <FavoriteRoundedIcon /> : <EditIconRounded />}
        onClick={e => {
          // e.stopPropagation();
          if (isEditMode) {
            handleSave();
            setIsEditMode(false);
          } else {
            setIsEditMode(true);
          }
        }}
      >
        {isEditMode ? 'Save' : 'Edit'}
      </Button>
    </SaveBox>
  );
};

export default SaveBoxPointer;
